module.exports = __webpack_public_path__ + "img/move.5eb85e96.svg";